<template>
    <div id='monitoramento'>
        <div class="row">
            <div class="col-md-12">
                <vuestic-widget headerText="Monitoramento das Aulas Práticas">
                    teste
                </vuestic-widget>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>

<style>

</style>
